import React from 'react'
import EmailEditor from '../../../helpers/email-editor/EmailEditor'

function EmailNewsLetter() {
  return (
   <>
      <EmailEditor /> 
   </>
  )
}

export default EmailNewsLetter